import { ExclamationCircleOutlined } from '@ant-design/icons';

export const ErrorMessage = ({ message }) => {
    return message ? (
      <div className="error-message">
        <ExclamationCircleOutlined /> {message}
      </div>
    ) : null;
  };